import React from 'react'
import { Tile } from '../templates'
import mapType from '../mapType'
import TYPE from '../../../api/types'

const Products = ({ data }) => {
  return (
    <div>
      {data.map(({ data, media, id }) => (
        <Tile
          image={media[0]}
          title={data.title}
          description={`${data.position}, ${data.country}`}
          key={id}
        />
      ))}
    </div>
  )
}

Products.defaultProps = {
  data: [],
}

export default mapType(TYPE.PRODUCT)(Products)
